module.exports = __webpack_public_path__ + "static/media/Apple iPhone XS Max Space Grey.9e21bc8f.png";